var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitData()}}},[_c('h1',[_vm._v("Agregar Tratamiento Antiretroviral")]),_c('v-container',[_c('h3',[_vm._v("Tratamiento")]),_c('p',[_vm._v("Por implementar")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }